import React from "react"
import PropTypes from "prop-types"
import SanityImage from "gatsby-plugin-sanity-image"

const Headshot = ({ shape, ...props }) => (
  <SanityImage
    height={props.width}
    config={{ saturation: -100 }}
    css={{
      clipPath: `url(#${shape})`,
      filter: "saturate(0%)",
    }}
    {...props}
  />
)

export default Headshot

Headshot.propTypes = {
  width: PropTypes.number,
  shape: PropTypes.oneOf([
    "hourglass",
    "sourglass",
    "burger",
    "hotDogs",
    "silo",
    "fallenSilo",
    "square",
    "squircle",
    "circle",
    "octagon",
  ]),
}
